import React from "react";
import PropTypes from "prop-types";
import { Nav, Row, Col, Container } from "react-bootstrap";
import NavbarNavLink from "./NavbarNavLink";
import styles from "./landing.module.css";
import { useTranslation } from "react-i18next";
import useWindowWidth from "components/forms/custom/WindowsSize/useWindowWidth";
import NavbarDropdown from "./NavbarDropdown";
import { useLocation } from "react-router-dom";

const NavbarDropdownPages = ({ items, onItemClick }) => {
	const [t, i18n] = useTranslation();
	const width = useWindowWidth();
	const isMobile = width <= 768;
	const location = useLocation();

	const isParentActive = (parent) => {
		if (!parent.children || parent.children.length === 0) return false;

		return parent.children.some((child) => {
			if (child.to && location.pathname.startsWith(child.to)) {
				return true; // child matches current route
			}
			// Recursively check deeper children
			return isParentActive(child);
		});
	};
	const renderRoutes = (routes) => {
		const rows = [];
		for (let i = 0; i < routes.length; i += 3) {
			const pair = routes.slice(i, i + 3); // take two items per row

			rows.push(
				<Container key={`container-${i}`} className="pb-2 pt-2">
					<Row key={`row-${i}`}>
						{pair.map((route, colIndex) => (
							<Col xs={12} sm={12} md={4} key={`col-${i}-${colIndex}-${route.name}`}>
								<Nav className={`flex-column fw-medium ${styles.mainPageMenu}`}>
									{Array.isArray(route.children) && route.children.length > 0 ? (
										<>
											{!isMobile ? (
												<>
													{/* Parent */}
													<NavbarNavLink isParent={true} title={t(route.name)} route={route} key={`parent-${route.name}`} />

													{/* Children */}
													{route.children.map((child, childIndex) => (
														<NavbarNavLink
															selectedChild={child.to ? location.pathname === child.to.split("?")[0] : false}
															key={`child-${i}-${colIndex}-${childIndex}-${child.name}`}
															route={child}
															onClick={onItemClick}
														/>
													))}
												</>
											) : (
												<>
													<NavbarDropdown key={route.name} classes={`${styles.menuDropDown} ${isParentActive(route) ? styles.mainPageSubMenuSelected : ""}`} title={t(route.name)}>
														<NavbarDropdownPages items={route.children} onItemClick={onItemClick} />
													</NavbarDropdown>
												</>
											)}
										</>
									) : (
										<NavbarNavLink selectedChild={location.pathname === route.to?.split("?")[0]} key={`link-${i}-${colIndex}-${route.name}`} route={route} onClick={onItemClick} />
									)}
								</Nav>
							</Col>
						))}
					</Row>
				</Container>
			);
		}
		return rows;
	};

	return <>{renderRoutes(items)}</>;
};

NavbarDropdownPages.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
			name: PropTypes.string.isRequired,
			to: PropTypes.string,
			children: PropTypes.array,
			onItemClick: PropTypes.func, // ✅ optional function
		})
	).isRequired,
};

export default NavbarDropdownPages;
